import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as React from 'react';

import { ControlButton, type ControlButtonProps } from '../ControlButton';

export type IDrawButtonProps = Omit<ControlButtonProps, 'title' | 'handleClick'> & {
  hasPolygons: boolean;
  onActivateClick(): void;
  onCancelClick(): void;
  icon: JSX.Element;
};

export const DrawButton: React.FC<IDrawButtonProps> = ({
  hasPolygons,
  onActivateClick,
  onCancelClick,
  icon,
  isActive,
  ...sharedProps
}) => {
  const handleClick = React.useCallback(() => {
    if (hasPolygons) {
      onCancelClick();
    } else {
      onActivateClick();
    }
  }, [hasPolygons, onActivateClick, onCancelClick]);

  return (
    <ControlButton
      {...sharedProps}
      data-name="DrawButton"
      handleClick={handleClick}
      icon={hasPolygons ? <IconActionClose16 color={isActive ? 'white_100' : 'black_100'} /> : icon}
      isActive={isActive}
      tooltipTitle="Выделение области"
    />
  );
};
